export default __webpack_public_path__ + "static/media/mayday.511cfa29.mp3";